import React from "react";
import { Link } from "react-router-dom";

const Sales = (props) => {
  return (
    <>
      <section className="md:py-24 py-12">
        <div className="container sm:container md:container lg:container w-full mx-auto text-center">
          <h2 className="text-center text-2xl md:text-4xl text-blue-800 font-avenirHeavy leading-normal">
            {props.title}
          </h2>
          <Link to="/contact">
            <button className="brand-primary-btn mt-10">Contact Us</button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default Sales;
